module.exports = __webpack_public_path__ + "static/media/1f527.4d228afd.png";